import { Selector } from "@reduxjs/toolkit";

import { ModulFState } from "../store";

import { OperationLockState } from "./types";

export function selectOperationLoadingState(operationName: string): Selector<ModulFState, string | undefined> {
	return state => {
		const operation = state.operations.loadingState.find(op => op.operationName === operationName);
		return operation?.loadingState;
	};
}

export function selectOperationLockState(
	reference: string | undefined
): Selector<ModulFState, OperationLockState | undefined> {
	return state => {
		if (!state || !reference || !state.operations || !state.operations.lockState) {
			return undefined;
		}
		return state.operations.lockState.find(ls => ls.reference === reference);
	};
}

export function selectOperationLockStateByGroup(
	group: string | undefined
): Selector<ModulFState, OperationLockState[]> {
	return state => {
		if (!state || !group || !state.operations || !state.operations.lockState) {
			return [];
		}
		return state.operations.lockState.filter(ls => ls.group === group);
	};
}

export function selectLastCreatedProcessBusinessKey(): Selector<ModulFState, string | undefined> {
	return state => {
		return state.operations.lastCreatedProcessBusinessKey;
	};
}
